import { Box, BoxProps, Skeleton, Stack } from "@mui/material";

interface ILoadingStateProps extends BoxProps {
    isAnimated?: boolean;
}

interface IRowProps {
    isAnimated: boolean;
    firstColumnWidth: number;
}

const SKELETON_COLUMN_COUNT = 3;

const LoadingRow = ({ isAnimated, firstColumnWidth }: IRowProps) => {
    const animation = isAnimated ? "pulse" : false;
    const backgroundColor = isAnimated ? undefined : "gray.100";

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Skeleton variant="rectangular" animation={animation} sx={{ height: 8, width: firstColumnWidth, backgroundColor }} />
            </Box>
            <Skeleton variant="rectangular" animation={animation} sx={{ height: 8, width: 64, flexShrink: 0, ml: 4, backgroundColor }} />
            {Array.from({ length: SKELETON_COLUMN_COUNT }, (_, index) => (
                <Skeleton
                    key={index}
                    variant="rectangular"
                    animation={animation}
                    sx={{ height: 8, width: 64, flexShrink: 0, ml: 4, backgroundColor, display: { xs: "none", sm: "block" } }}
                />
            ))}
        </>
    );
};

export const LoadingState = ({ isAnimated = true, ...boxProps }: ILoadingStateProps) => {
    return (
        <Box aria-hidden={true} {...boxProps}>
            <Stack
                direction="row"
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: 72,
                    borderTop: "2px solid",
                    borderBottom: "2px solid",
                    borderColor: "gray.100",
                }}
            >
                <LoadingRow isAnimated={isAnimated} firstColumnWidth={64} />
            </Stack>
            {[1, 2, 3, 4, 5, 6, 7].map(i => (
                <Stack
                    key={i}
                    direction="row"
                    sx={{ alignItems: "center", justifyContent: "space-between", height: 64, borderBottom: "1px solid", borderColor: "gray.100" }}
                >
                    <LoadingRow isAnimated={isAnimated} firstColumnWidth={120} />
                </Stack>
            ))}
        </Box>
    );
};
